import { render, staticRenderFns } from "./notification-dropdown-item.vue?vue&type=template&id=0434ef3a&"
import script from "./notification-dropdown-item.vue?vue&type=script&lang=ts&"
export * from "./notification-dropdown-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports